<template>
<div>
    <smallbutton :toplabel="buttonText" @click="Show()" v-if="showButton" :disabled="disabled" :buttonclass="buttonclass"/>
    <linkbutton :toplabel="buttonText" @click="Show()" v-if="showLink" :disabled="disabled"/>
    <removebutton @click="Show()" v-if="showImageButton" :disabled="disabled"/>

    <!-- MODAL -->
      <actionmodal ref="mymodal"> 
        <template v-slot:body>
            <label class="titlelabel">{{title}}</label>
            <label :class="textclass">{{body}}</label>
            <div>
                <smallbutton  @click="CloseWithYes" toplabel="Yes"/>
                <smallbutton  @click="$refs.mymodal.closeModal()" :toplabel="noLabel"/>
            </div>
            <div>
              <label class="responsemessage">{{responseMessage}}</label>
            </div>
        </template>
      </actionmodal>
    </div>
</template>

<script>
import smallbutton from '../controls/button.vue'
import actionmodal from '../controls/actionmodal.vue'
import linkbutton from '../controls/linkbutton.vue'
import removebutton from '../controls/removebutton.vue'
export default {
    name:'confirm',
    components:{
        smallbutton,
        actionmodal,
        linkbutton,
        removebutton
    },
    props:{
        buttonLabel:{
            type:String,
            default:""
        },
        title:{
            type:String,
            required:true,
            default:''
        },
        body:{
            type:String,
        },
        showButton:{
            type:Boolean,
            default:false
        },
        showImageButton:{
            type:Boolean,
            default:false,
        },
        showLink:{
            type:Boolean,
            default:false
        },
        disabled:{
          type:Boolean,
          default:false
        },
        buttonclass:{
            type:String,
            default:"button primarybutton"
        },
        redText:{
            type:Boolean,
            default:false,
        },
        greenText:{
            type:Boolean,
            default:false,
        },
        noLabel:{
            type:String,
            default:'No'
        }
    },
    data(){
        return{
            responseMessage:''
        }
    },
    computed:{
        buttonText(){
            if (this.buttonLabel==""){return this.title}
            else{return this.buttonLabel}
        },
        textclass(){
            if(this.redText){return "responsemessage"}
            else if(this.greenText){return "greentext"}
            else{return ""}
        }
    },
    methods:{
        
        Show(){
            this.$refs.mymodal.openModal()
        },
        async CloseWithYes(){
            this.$emit('yes')
            this.$refs.mymodal.closeModal()
        }
    }
}
</script>

<style>
.greentext{
    color:green;
    font-size:large;
}
</style>